export { default } from "./page-british-columbia";
